import { takeEvery } from 'redux-saga/effects';

// internal
import * as Action from '@app/store/typings/actions/device.d';
import { fetchDeviceWithZone } from '@app/store/sagas/device/fetch';

export function* deviceSaga() {
  yield takeEvery(Action.KEY_DEVICE_ZONE_FETCH, fetchDeviceWithZone);
}
